import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TopToolbar,
  Button,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';

const CrashPresetListActions = () => {
  const navigate = useNavigate();
  return (
    <TopToolbar>
      <Button
        label="Bulk add"
        onClick={() => navigate('/crash-presets/bulk-add')}
      />
    </TopToolbar>
  );
};

export const CrashPresetList = (props) => (
  <List {...props} actions={<CrashPresetListActions />}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="multiplier" />
    </Datagrid>
  </List>
);